export const pricingToggleContent = {
    fr: { screen: '1 Écran', multi: 'Multi-écrans' },
    es: { screen: '1 Pantalla', multi: 'Multi-pantallas' },
};
